export default __webpack_public_path__ + "4521150871a353a405db9d63929576b5.png";